<template>
  <div class="booking-overview">
    <BookingSeats
      :time-periods="timePeriods"
      :staffs="staffs"
      :services="services"
      :bookings="bookingList"
      :maximum-booking-slot-count="maximumBookingSlotCount"
      :show-mode-selection="true"
      :enable-booking-creation="true"
      :cell-min-height="130"
      @create-booking="handleCreateBooking"
    />
  </div>
</template>

<script>
import BookingSeats from '@/components/Dashboard/Booking/BookingSeats.vue'

export default {
  components: {
    BookingSeats
  },
  data() {
    return {
      bookingList: [
        { id: 1, title: '預約 A', timePeriodId: 1, staffId: 2, serviceId: 1 },
        { id: 2, title: '預約 B', timePeriodId: 1, staffId: 4, serviceId: 1 },
        { id: 3, title: '預約 C', timePeriodId: 2, staffId: 1, serviceId: 2 },
        { id: 4, title: '預約 D', timePeriodId: 3, staffId: 3, serviceId: 3 },
        { id: 5, title: '預約 E', timePeriodId: 4, staffId: 2, serviceId: 1 },
        { id: 6, title: '預約 F', timePeriodId: 1, staffId: 1, serviceId: 1 },
        { id: 7, title: '預約 G', timePeriodId: 1, staffId: 3, serviceId: 1 },
        { id: 8, title: '預約 H', timePeriodId: 2, staffId: 3, serviceId: 2 },
        { id: 9, title: '預約 I', startAt: '2026-04-01 15:21', endAt: '2026-04-01 21:59', staffId: 4, serviceId: 5 },
      ],
      nextBookingId: 10
    }
  },
  computed: {
    timePeriods() {
      return [
        { id: 1, start: '09:00', end: '12:00' },
        { id: 2, start: '12:15', end: '15:00' },
        { id: 3, start: '15:20', end: '18:30' },
        { id: 4, start: '18:45', end: '22:00' }
      ]
    },
    maximumBookingSlotCount() {
      return 5
    },
    staffs() {
      return [
        { id: 1, name: '員工 A' },
        { id: 2, name: '員工 B' },
        { id: 3, name: '員工 C' },
        { id: 4, name: '員工 D' },
      ]
    },
    services() {
      return [
        { id: 1, name: '服務 A', maximun: 4 },
        { id: 2, name: '服務 B', maximun: 2 },
        { id: 3, name: '服務 C', maximun: 5 },
        { id: 4, name: '服務 D', maximun: 6 },
        { id: 5, name: '服務 E', maximun: 3 },
      ]
    },
  },
  methods: {
    handleCreateBooking({ timePeriod, staff, service }) {
      this.bookingList.push({
        id: this.nextBookingId++,
        title: `預約 ${String.fromCharCode(64 + this.nextBookingId)}`,
        timePeriodId: timePeriod.id,
        staffId: staff.id,
        serviceId: service.id
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
